import { render, staticRenderFns } from "./MyPopoverHover.vue?vue&type=template&id=8c823e9c&scoped=true"
import script from "./MyPopoverHover.vue?vue&type=script&lang=js"
export * from "./MyPopoverHover.vue?vue&type=script&lang=js"
import style0 from "./MyPopoverHover.vue?vue&type=style&index=0&id=8c823e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c823e9c",
  null
  
)

export default component.exports